import WelfareContributionPage from '@/common/pages/(private)/(dashboard)/welfare/contribution/[slug]';

export default function Page() {
  return <WelfareContributionPage />;
}
